import React, { useEffect, useMemo, useState } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { image } from '../../../../utils/data/baseUrl'
import StatsTimeCircle from './StatsTimeCircle'
import { isAlfaGameActive } from '../../../../utils/game/isAlfaGameActive'
import { isJumperForMeAssets } from '../../../../utils/game/isJumperForMeAssets'
import { isJumperAdidasAssets } from '../../../../utils/game/isJumperAdidasAssets'
import { isPlatformBourjoisAssets } from '../../../../utils/game/isPlatformBourjoisAssets'
import { isJumperRimmelAssets } from '../../../../utils/game/isJumperRimmelAssets'

const DASH_MIN = 100
const DASH_MAX = 188

const boostersImages = {
  spring: 'games/time/5.png',
  jetpack: 'games/time/4.png',
  big_basket: 'games/time/2.png',
  reverse: 'games/time/1.png',
  magnet: 'games/time/3.png',
  infection: 'games/time/6.png',
}

const boostersImagesAlfa = {
  reverse: 'games/time/alfa/1.png',
  big_basket: 'games/time/alfa/2.png',
  magnet: 'games/time/alfa/3.png',
  infection: 'games/time/alfa/6.png',
}

const boostersImagesForMe = {
  spring: 'games/time/for-me/5.png',
  jetpack: 'games/time/for-me/4.png',
}

const boostersImagesAdidas = {
  spring: 'games/time/adidas/5.png',
  jetpack: 'games/time/adidas/4.png',
}

const boostersImagesRimmel = {
  spring: 'games/time/rimmel/5.png',
  jetpack: 'games/time/rimmel/4.png',
}

const boostersImagesBourjois = {
  reverse: 'games/time/bourjois/1.png',
  big_basket: 'games/time/bourjois/2.png',
  magnet: 'games/time/bourjois/3.png',
  infection: 'games/time/bourjois/6.png',
}

const StatsTime = React.forwardRef(function StatsTime({ eventBus, timer, type }, ref) {
  const [booster, setBooster] = useState(0)
  const [countTime, setCountTime] = useState(0)
  const [dash, setDash] = useState('188')

  useEffect(() => {
    if (!eventBus) return

    const boosterOnUpdate = ({ data }) => {
      setBooster(data?.progress !== 1 && data)
      setCountTime(100 - data.progress * 100)
    }

    eventBus.addEventListener('booster:update', boosterOnUpdate)
    return () => eventBus.removeEventListener('booster:update', boosterOnUpdate)
  }, [eventBus])

  useEffect(() => {
    if (booster?.progress !== undefined) {
      const line = DASH_MAX - DASH_MIN
      setDash(DASH_MIN + (line / 100) * countTime)
    }
  }, [countTime])

  const busterImage = useMemo(() => {
    if (type === 'platformer' && isAlfaGameActive()) {
      return boostersImagesAlfa?.[booster?.type]
    }

    if (type === 'platformer' && isPlatformBourjoisAssets()) {
      return boostersImagesBourjois?.[booster?.type]
    }

    if (type === 'doodle' && isJumperForMeAssets()) {
      return boostersImagesForMe?.[booster?.type]
    }

    if (type === 'doodle' && isJumperAdidasAssets()) {
      return boostersImagesAdidas?.[booster?.type]
    }

    if (type === 'doodle' && isJumperRimmelAssets()) {
      return boostersImagesRimmel?.[booster?.type]
    }

    return boostersImages?.[booster?.type]
  }, [booster?.type])

  return (
    <>
      {timer && (
        <TransitionGroup component={null}>
          {countTime > 0 && (
            <CSSTransition
              key={countTime > 0}
              timeout={{ enter: 300, exit: 300 }}
              classNames={'stats__time'}
            >
              <div className={'stats__time'}>
                <div className={'stats__time-block'}>
                  {busterImage && (
                    <img
                      className={'stats__time-image'}
                      src={image(busterImage)}
                    />
                  )}
                  <StatsTimeCircle dash={dash} />
                </div>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
      )}
    </>
  )
})
export default StatsTime
StatsTime.propTypes = {}
